var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useLazyQuery, useMutation } from '@apollo/client/react';
import { FileSystemDocumentDownloadFormat } from 'shared/domains/apollo/generated/types';
import { useAccount } from 'shared/domains/users';
import { GetLogoDocument } from './GetLogo.gql';
import { GetPdfDocument } from './GetPdf.gql';
const FORMAT = FileSystemDocumentDownloadFormat.Pdf;
export function useGetPdf() {
    const { data: accountData } = useAccount();
    const [mutate] = useMutation(GetPdfDocument);
    const [query] = useLazyQuery(GetLogoDocument);
    const getLogoUrl = () => __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        const { data } = yield query({ variables: { companyId: accountData.companyId } });
        const logoPath = (_a = data === null || data === void 0 ? void 0 : data.company) === null || _a === void 0 ? void 0 : _a.logoPath;
        const logoUploaded = (_b = data === null || data === void 0 ? void 0 : data.company) === null || _b === void 0 ? void 0 : _b.logoUploaded;
        const logoUrl = logoUploaded && logoPath ? `${process.env.CDN_URL}/${logoPath}` : undefined;
        return logoUrl;
    });
    const getPdf = (documentId) => __awaiter(this, void 0, void 0, function* () {
        var _c, _d;
        const logoUrl = yield getLogoUrl();
        const appUrl = (_d = (_c = process.env.RENDER_SERVICE_CSS_FILE_APP_URL) !== null && _c !== void 0 ? _c : process.env.APP_URL) !== null && _d !== void 0 ? _d : window.location.origin;
        const cssUrl = new URL('/public/pdf.css', appUrl).toString();
        return mutate({
            variables: {
                input: {
                    documentId,
                    cssUrl,
                    logoUrl,
                    downloadFormat: FORMAT,
                },
            },
        });
    });
    return { getPdf };
}
